/** Prefer UUID; fall back when crypto.randomUUID is missing or blocked (e.g. http://LAN-IP). */
export function createId(): string {
  try {
    return globalThis.crypto.randomUUID();
  } catch {
    // Missing crypto, or insecure contexts where randomUUID throws.
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(16).slice(2, 10)}`;
}
